import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from "react-intl";

import FormattedNumberWithCurrency from "components/formattedNumberWithCurrencies/formattedNumberWithCurrency";
import Badge from "components/Badge";

import Detail from "./Detail";

import {green700, red700} from "assets/jss/main";

BenchmarkPrice.propTypes = {
    benchmarkPrice: PropTypes.number,
    priceCompetitiveness: PropTypes.number,
    currency: PropTypes.string
};

function BenchmarkPrice({benchmarkPrice, priceCompetitiveness,  currency}) {
    const intl = useIntl();
    const isCompetitivenessPositive = priceCompetitiveness > 0;

    if (benchmarkPrice === null || priceCompetitiveness === null) {
        return
    }

    return (
        <Detail
            name={intl.formatMessage({id: 'product.show.resume.details.benchmarkPrice'})}
            tooltipMessageId={'product.show.resume.details.benchmarkPrice.tooltip'}
            value={(
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <FormattedNumberWithCurrency
                        value={benchmarkPrice}
                        currency={currency}
                    />
                    <Badge
                        border={true}
                        isBold={false}
                        labelColor={isCompetitivenessPositive ? red700 : green700}
                        color={isCompetitivenessPositive ? 'error' : 'online'}
                    >
                        {intl.formatNumber(priceCompetitiveness / 100, {
                            style: 'percent',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}
                    </Badge>
                </div>
            )}
        />
    );
}

export default BenchmarkPrice;
